import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Campus } from 'src/app/models/campus.model';
import { Family } from 'src/app/models/family.model';
import { Poll } from 'src/app/models/poll.model';
import { School } from 'src/app/models/school.model';
import { Section } from 'src/app/models/section.model';
import { EscolarService } from 'src/app/services/escolar.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-form-poll',
  template: `
    <form [formGroup]="formPoll">
      <div class="form-group mt-2">
        <label for="generic_type" class="form-control-label text-dark mb-1 ms-2">¿A quien va dirigido?</label>
        <select class="form-select rounded-3 border-secondary" formControlName="generic_type" (change)="selectType($event)">
          <option value="0" selected disabled>Selecciona...</option>
          <option *ngFor="let type of generic_types" [value]="type.id" [selected]="type.id === ff['generic_type'].value">{{type.title}}</option>
        </select>
      </div>
      <div class="form-group mt-4" *ngIf="ff['generic_type'].value != 1">
        <label for="generic_id" class="form-control-label mb-1 ms-2 text-dark">Selecciona los destinatarios</label>
        <div *ngIf="dropdownList.length>0&&!loadingIds">
          <ng-multiselect-dropdown
            [settings]="dropdownSettings"
            [data]="dropdownList"
            [(ngModel)]="selectedItems"
            (onSelect)="onItemSelect($event)"
            (onSelectAll)="onSelectAll($event)"
            class="border-secondary"
            [ngModelOptions]="{standalone: true}"
          >
          </ng-multiselect-dropdown>
        </div>
        <div class="ms-2 mt-1" *ngIf="loadingIds">
          <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="text-dark"></fa-icon>
          <span class="text-muted text-sm ms-2">Cargando información...</span>
        </div>
      </div>
      <div class="form-group mt-4">
        <label for="title" class="form-label ms-2">Título del evento</label>
        <input type="text" class="form-control border-secondary" formControlName="title" placeholder="Título de la evento">
      </div>
      
      <!-- div class="form-group mb-4 mt-3">
        <label for="name" class="form-label ms-2">Campus</label>
        <select class="form-select" formControlName="campus_id" (change)="selectCampus($event)">
          <option *ngFor="let campus of campuses" [value]="campus.campus_id">{{campus.name}}</option>
        </select>
      </!-->

      <div class="form-group mt-4">
        <label for="options" class="form-label ms-2">Opciones de la encuesta</label>
        <div *ngFor="let option of options; let i = index" class="d-flex align-items-center mb-2">
          <input type="text" class="form-control border-secondary me-2" [formControlName]="'option_' + i" placeholder="Opción {{i + 1}}">
          <button type="button" class="btn btn-outline-danger" (click)="removeOption(i)">
            <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
          </button>
        </div>
        <button type="button" class="btn btn-outline-primary mt-2" (click)="addOption()">
          <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>Agregar opción
        </button>
      </div>

      <div class="form-group text-end mt-5">
        <hr style="border-color: rbga(0,0,0,0.4);">
        <div class="d-flex flex-wrap">
          <div class="ms-auto">
            <button *ngIf="poll?.id" class="btn btn-outline-danger" (click)="deletePoll()">
              <fa-icon [icon]="icons.faTrashAlt" class="me-0 me-md-2"></fa-icon>
              <span class="d-none d-sm-none d-md-inline-block">Eliminar</span>
            </button>
          </div>
          <div class="flex-fill">
            <div class="form-check form-switch float-end ms-3">
              <label class="text-w500 text-sm pt-1" for="flexSwitchCheckDefault"><fa-icon [icon]="icons.faCircleInfo"></fa-icon></label>              
              <input class="form-check-input form-check-input-lg me-3" type="checkbox" role="switch" id="flexSwitchCheckDefault" formControlName="notify">              
            </div>
            <div class="form-group required mb-0 mt-0 text-end">
              <button type="button" class="btn btn-link text-dark me-2" routerLink="/polls">Cancelar</button>
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn btn-escalas" id="dropdownBasic1" ngbDropdownToggle>
                  Guardar <fa-icon [icon]="icons.faChevronDown" class="ms-2"></fa-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button type="button" ngbDropdownItem (click)="pollPublish()">
                    <fa-icon [icon]="icons.faPaperPlane" class="me-2"></fa-icon> 
                    Publicar
                  </button>
                  <button type="button" ngbDropdownItem *ngIf="poll?.live">
                    <fa-icon [icon]="icons.faSave" class="me-2"></fa-icon>
                    Enviar a borrador
                  </button>
                  <button type="button" class="text-danger" ngbDropdownItem (click)="deletePoll()">
                    <fa-icon [icon]="icons.faTrashAlt" class="me-2"></fa-icon>
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  `,
  styles: ``
})
export class FormPollComponent {
  @Input() poll: Poll | null = null;
  @Input() loading: boolean = false;
  @Input() school: School | null = null;
  @Input() campuses: Campus[] = [];
  @Output() pollData = new EventEmitter<Poll>();

  sections: Section[] = [];
  families: Family[] = [];

  formPoll: FormGroup = new FormGroup({});

  loadingIds: boolean = false;
  dropdownList: any[] = [];
  selectedItems: any[] = [];
  dropdownSettings: any = {};

  generic_types: any[] = [
    { id: 1, title: "Todos" },
    { id: 3, title: "Grupo" },
    { id: 5, title: "Familia"}
  ];

  options: string[] = [];

  constructor(
    private escolarService: EscolarService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public icons: IconsService
  ) {}

  ngOnInit(): void {
    this.initForm();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Seleccionar Todo',
      unSelectAllText: 'Deseleccionar Todo',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  initForm() {
    this.formPoll = this.fb.group({
      generic_type: [null], // Initialize generic_type control
      title: [''],
      notify: [false]
      // Add other controls as needed
    });
    this.addOption(); // Initialize with one option
  }

  addOption() {
    const optionIndex = this.options.length;
    this.options.push('');
    this.formPoll.addControl(`option_${optionIndex}`, this.fb.control(''));
  }

  removeOption(index: number) {
    this.options.splice(index, 1);
    this.formPoll.removeControl(`option_${index}`);
    // Re-index remaining options
    this.options.forEach((_, i) => {
      if (i >= index) {
        const control = this.formPoll.get(`option_${i + 1}`);
        if (control) {
          this.formPoll.addControl(`option_${i}`, control);
          this.formPoll.removeControl(`option_${i + 1}`);
        }
      }
    });
  }

  loadSelectedItems(event: any) {
    if (!event) return;
    const genericIds = event.generic_id?.split(',').map((id: any) => parseInt(id));
    if (event.generic_type === 3) {
      this.selectedItems.push(
        ...genericIds.map((id: any) => {
          const section = this.sections.find((s: any) => s.section_id === id);
          return section
            ? { item_id: section.section_id, item_text: `${section?.section ? section.section : ''} ${section?.grade ? section.grade : ''} ${section?.group ? section.group : ''}` }
            : null;
        }).filter((item: any) => item !== null)
      );
    } else if (event.generic_type === 5) {
      this.selectedItems.push(
        ...genericIds.map((id: any) => {
          const family = this.families.find((s: any) => s.family_id === id);
          return family
            ? { item_id: family.family_id, item_text: `${family.name}` }
            : null;
        }).filter((item: any) => item !== null)
      );
    }    
  }

  get ff() {
    return this.formPoll.controls;
  }

  selectType(event: any) {
    this.loadTypes(event.target.value);
  }

  async loadTypes(id: number) {
    try {
      this.dropdownList = [];
      this.selectedItems = [];
      
      if (id == 1) {
        // this.loadCampus();    
      } else if (id == 3) {
        await this.loadSections();
      } else if (id == 4) {
        await this.loadSections();
      } else if (id == 5) {
        await this.loadFamilies();
      }
    } catch (error) {
      console.error('Error loading types:', error);
      this.toastr.error('Error al cargar los tipos', 'Error');
    }
  }

  onItemSelect(item: any) {}

  onSelectAll(items: any) {}

  selectCampus(campus: any) {
    this.escolarService.getSections({ campus_id: campus.target.value }).subscribe((data: any) => {
      this.dropdownList = [];
      data.data.map((item: Section) => {
        this.dropdownList.push({ item_id: item.section_id, item_text: `${item?.section ? item.section : '' } ${item?.grade ? item.grade : '' } ${ item?.group ? item.group : '' }` });
      });
      this.sections = data.data;
    });
  }

  async loadSections() {
    this.loadingIds = true;
    this.escolarService.getSections({ 
      per_page: 600, 
      page: 1, 
      campus_id: this.campuses.map((item: any) => item.campus_id) 
    }).subscribe({
      next: (sections: any) => {
        this.sections = sections.data;
        this.sections.map((item: any) => {
          this.dropdownList?.push({ 
            item_id: item.section_id, 
            item_text: `${item?.section ? item?.section : ''} ${item?.grade ? item?.grade : ''} ${item?.group ? item?.group : ''}` 
          });
        });
        this.loadSelectedItems(this.poll);
        this.loadingIds = false;
      },
      error: (error: any) => {
        this.toastr.error('Error al cargar las secciones', 'Error');
        console.error('Error loading sections', error);
        this.loadingIds = false
      }
    });
  }

  async loadFamilies() {
    this.loadingIds = true;
    this.escolarService.getFamilies({ 
      per_page: 600, 
      page: 1, 
      campus_id: this.campuses.map((item: any) => item.campus_id) 
    }).subscribe({
      next: (families: any) => {
      this.families = families.data;
      this.families.map((item: any) => { this.dropdownList.push({ item_id: item.family_id, item_text: item.name }) });
      this.loadingIds = false;
      this.loadSelectedItems(this.poll);    
      },
      error: (error: any) => {
        this.toastr.error('Error al cargar las familias', 'Error');
        console.error('Error loading families', error);
        this.loadingIds = false;
      }
    });
  }

  deletePoll() {}

  pollPublish() {
    if (this.formPoll.invalid) {
      this.toastr.error('Por favor completa todos los campos requeridos.', 'Error');
      return;
    }

    const pollData = {
      ...this.formPoll.value,
      options: this.options.map((_, i) => this.formPoll.get(`option_${i}`)?.value).filter((option) => option) // Collect non-empty options
    };

    if (this.poll?.id) {
      this.escolarService.updatePoll(this.formPoll.value.id, pollData).subscribe({
        next: () => this.toastr.success('Encuesta actualizada con éxito.', 'Éxito'),
        error: () => this.toastr.error('Error al actualizar la encuesta.', 'Error')
      });
    } else {
      this.escolarService.createPoll(pollData).subscribe({
        next: () => this.toastr.success('Encuesta creada con éxito.', 'Éxito'),
        error: () => this.toastr.error('Error al crear la encuesta.', 'Error')
      });
    }
  }
  
}
